import { FancyBadge } from '@ui/components/FancyBadge';
import { FloatingBanner } from '@ui/components/FloatingBanner';

import {
  AUDIO_AND_MIC_BLOCKED_TEXT,
  AUDIO_BLOCKED_TEXT,
  MIC_ISSUE_BUTTONS,
  MIC_ISSUE_TEXTS,
} from '@features/video/constants';
import { MicIssue } from '@features/video/types';

type Props = {
  issue?: MicIssue;
  // браузер не дал играть звук без клика
  audioBlocked?: boolean;
  onFix: () => void;
};

// Микрофон или звук молчат в эфире: плашка с кнопкой всегда на виду, поверх шапки
// и модалок. Один клик чинит все сразу
export function MicIssueBanner({ issue = null, audioBlocked = false, onFix }: Props) {
  if (!issue && !audioBlocked) return null;
  const { text, button } = describe(issue, audioBlocked);
  return (
    <FloatingBanner>
      {text}
      <FancyBadge onClick={onFix}>{button}</FancyBadge>
    </FloatingBanner>
  );
}

/*
    ____,-------------------------------,____
    \   |            Helpers            |   /
    /___|-------------------------------|___\
*/

function describe(issue: MicIssue, audioBlocked: boolean): { text: string; button: string } {
  if (issue && audioBlocked) {
    return {
      text:
        issue === 'gesture'
          ? AUDIO_AND_MIC_BLOCKED_TEXT
          : `${MIC_ISSUE_TEXTS[issue]} ${AUDIO_BLOCKED_TEXT}`,
      button: 'Включить',
    };
  }
  if (issue) return { text: MIC_ISSUE_TEXTS[issue], button: MIC_ISSUE_BUTTONS[issue] };
  return { text: AUDIO_BLOCKED_TEXT, button: 'Включить звук' };
}
